import React, { useState } from "react";
import { FiActivity, FiDroplet, FiAlertTriangle, FiUser, FiDollarSign, FiFileText } from "react-icons/fi";
import { MdOutlineWaterDrop } from "react-icons/md";
import { GiTap, GiWaterRecycling } from "react-icons/gi";
import { waterDummyData } from "../../Data/WaterData";
import { DashboardHeader } from "../../components/Shared";
import WmOverviewPanel    from "./panels/WmOverviewPanel";
import WmTankPanel        from "./panels/WmTankPanel";
import WmSourcePanel      from "./panels/WmSourcePanel";
import WmConsumptionPanel from "./panels/WmConsumptionPanel";
import WmFlatMeteringPanel from "./panels/WmFlatMeteringPanel";
import WmBillingPanel     from "./panels/WmBillingPanel";
import WmLeakagePanel     from "./panels/WmLeakagePanel";
import WmPumpPanel        from "./panels/WmPumpPanel";
import WmAlertsPanel      from "./panels/WmAlertsPanel";
import WmReportsPanel     from "./panels/WmReportsPanel";
import "../Dashboard.css";
import "./WaterDashboard.css";

const TABS = [
  { id: "overview",     label: "Overview",         icon: FiActivity         },
  { id: "tanks",        label: "Tank Monitoring",  icon: MdOutlineWaterDrop },
  { id: "sources",      label: "Water Sources",    icon: GiTap              },
  { id: "consumption",  label: "Consumption",      icon: FiDroplet          },
  { id: "flats",        label: "Flat Metering",    icon: FiUser             },
  { id: "billing",      label: "Billing",          icon: FiDollarSign       },
  { id: "leakage",      label: "Leakage & AI",     icon: GiWaterRecycling   },
  { id: "pumps",        label: "Pumps & Motors",   icon: FiActivity         },
  { id: "alerts",       label: "Alerts",           icon: FiAlertTriangle    },
  { id: "reports",      label: "Reports",          icon: FiFileText         },
];

const WaterDashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const d = waterDummyData;

  const renderPanel = () => {
    switch (activeTab) {
      case "overview":    return <WmOverviewPanel    d={d} />;
      case "tanks":       return <WmTankPanel        d={d} />;
      case "sources":     return <WmSourcePanel      d={d} />;
      case "consumption": return <WmConsumptionPanel d={d} />;
      case "flats":       return <WmFlatMeteringPanel d={d} />;
      case "billing":     return <WmBillingPanel     d={d} />;
      case "leakage":     return <WmLeakagePanel     d={d} />;
      case "pumps":       return <WmPumpPanel        d={d} />;
      case "alerts":      return <WmAlertsPanel      d={d} />;
      case "reports":     return <WmReportsPanel     d={d} />;
      default:            return null;
    }
  };

  // Badge on Alerts tab
  const criticalCount = d.alerts.filter(a => a.severity === "Critical" && a.status !== "Closed").length;

  return (
    <div className="fm-container">
      <DashboardHeader currentSolutionType="water" />

      <div className="fm-tab-bar wm-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`fm-tab ${activeTab === tab.id ? "fm-tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={15} />
            <span>{tab.label}</span>
            {tab.id === "alerts" && criticalCount > 0 && (
              <span className="wm-tab-badge">{criticalCount}</span>
            )}
          </button>
        ))}
      </div>

      <div className="fm-panel">
        {renderPanel()}
      </div>
    </div>
  );
};

export default WaterDashboard;
